/** Only known project destinations may be used as ChatHub return links. */
export function projectChatReturnHref(value?: string | null): string | null {
  if (!value || !/^\/(?:companies\/[^/?#]+\/|workspaces\/[^/?#]+\/)?projects\/[^/?#]+(?:\?[^#]*)?$/.test(value)
    || /[\\\r\n]/.test(value)) return null;
  return value;
}

export function projectDecisionHref(projectId: string, decisionId: string, workspaceId?: string | null): string {
  const scope = workspaceId ? `/workspaces/${encodeURIComponent(workspaceId)}` : '';
  return `${scope}/projects/${encodeURIComponent(projectId)}?tab=decisions&decision=${encodeURIComponent(decisionId)}`;
}

/** Room and thread links use the same contract across ChatHub and project views. */
export function buildChatHref(roomId: string, threadId?: string, workspaceId?: string): string {
  return buildProjectChatHref({ roomId, threadId, workspaceId });
}

export function buildProjectChatHref({ roomId, threadId, returnTo, workspaceId }: {
  roomId: string; threadId?: string; returnTo?: string; workspaceId?: string | null;
}): string {
  const params = new URLSearchParams({ room: roomId });
  if (threadId) {
    params.set('threadId', threadId);
    // Room selection consumes `room`; retain the thread's scope independently.
    params.set('threadRoom', roomId);
  }
  const safeReturn = projectChatReturnHref(returnTo);
  if (safeReturn) params.set('returnTo', safeReturn);
  const scope = workspaceId ? `/workspaces/${encodeURIComponent(workspaceId)}` : '';
  return `${scope}/chat?${params.toString()}`;
}

/** Keep only recognized intent when an old /chat link enters the scoped shell. */
export function chatNavigationQuery(search: string): string {
  const input = new URLSearchParams(search);
  const output = new URLSearchParams();
  for (const key of ['room', 'roomId', 'threadId', 'threadRoom', 'call']) {
    const value = input.get(key);
    if (value && /^[A-Za-z0-9_-]{1,128}$/.test(value)) output.set(key, value);
  }
  if (input.get('invite') === 'true') output.set('invite', 'true');
  const returnTo = projectChatReturnHref(input.get('returnTo'));
  if (returnTo) output.set('returnTo', returnTo);
  return output.size ? `?${output.toString()}` : '';
}
